<template>
  <div>
    <div class="mask-list" ref="Mask">
      <div
        class="item"
        v-for="item of productList"
        :key="item.id"
        @click="goToBuy(item.id)"
      >
        <div class="left">
          <img :src="item.image" alt="" />
        </div>
        <div class="right">
          <div class="title">
            {{ item.store_name }}
          </div>
          <div class="money">￥{{ item.price }}</div>
          <div class="num">
            <span class="sale">已售出{{ item.sales }}件</span>
            <span class="stock">库存{{ item.stock }}件</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProducts } from "@api/store";
export default {
  name: "MaskList",
  data() {
    return {
      param: {
        page: 1,
        limit: 8,
        keyword: "",
        sid: 198,
        news: 0,
        priceOrder: "",
        salesOrder: ""
      },
      productList: [],
      loading: false,
      loadend: false
    };
  },
  created() {
    this.getProductsMes();
  },
  mounted() {
    this.$scroll(this.$refs.Mask, () => {
      !this.loading && this.getProductsMes();
    });
  },
  methods: {
    getProductsMes() {
      if (this.loading) return;
      if (this.loadend) return;
      this.loading = true;
      getProducts(this.param).then(res => {
        this.loading = false;
        if (res.status === 200) {
          this.productList = this.productList.concat(res.data);
          let productLength = Number(res.msg);
          if (this.productList.length === productLength) {
            this.loadend = true;
          }
          this.param.page += 1;
        }
      });
    },
    goToBuy(id) {
      this.$router.push({
        path: "/maskGoodsCon/" + id
      });
    }
  }
};
</script>

<style scoped>
.mask-list {
  padding: 0.3rem;
  background: #fff;
}
.mask-list .item {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.2rem;
  margin-top: 0.15rem;
  border-bottom: 1px solid #f5f5f5;
}
.mask-list .item .left {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 0.06rem;
}
.mask-list .item .left img {
  width: 100%;
  height: 100%;
}
.mask-list .item .right {
  flex: 1;
  margin-left: 10px;
}
.mask-list .item .right .title {
  font-size: 0.3rem;
  color: #222;
  height: 0.8rem;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}
.mask-list .item .right .money {
  font-size: 0.3rem;
  font-weight: bold;
  margin-top: 0.2rem;
  margin-bottom: 0.1rem;
  color: #fc4141;
}
.mask-list .item .right .num {
  display: flex;
  justify-content: space-between;
  margin-top: 0.1rem;
  font-size: 0.22rem;
  color: #aaa;
  font-weight: normal;
  margin: -0.02rem 0 0 0;
}
</style>
